import { createContext, useContext } from "react";

import type { FormRenderingContextValue as RendererFormRenderingContextValue } from "@/react/components/FormRenderer/contexts/FormRenderingContext";

import type { FormRenderingContextValue as EditorFormRenderingContextValue } from "./FormRenderingContext";

type FormRenderingContextValue =
  | RendererFormRenderingContextValue
  | EditorFormRenderingContextValue;

interface BlocksContextValue {
  useFormRenderingContext: () => FormRenderingContextValue;
}

const BlocksContext = createContext<BlocksContextValue | undefined>(undefined);

interface BlocksContextProviderProps {
  children: React.ReactNode;
  useFormRenderingContext: () => FormRenderingContextValue;
}
export const BlocksContextProvider = ({
  children,
  useFormRenderingContext,
}: BlocksContextProviderProps) => {
  const value = { useFormRenderingContext };
  return (
    <BlocksContext.Provider value={value}>{children}</BlocksContext.Provider>
  );
};

export const useBlocksContext = () => {
  const context = useContext(BlocksContext);
  if (!context) {
    throw new Error(
      "useBlocksContext must be used within a BlocksContextProvider",
    );
  }
  return context;
};
BlocksContext.displayName = "BlocksContext";
